import React from 'react';
import { withRouter } from 'react-router-dom';

import FieldModal from '../../../../components/modals/fieldModal';

class DeleteEngagementTeamsModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

            isDeleting: false
        }
    }

    actionButton = () => {
        this.setState({ isDeleting: true });

        this.props.deleteEngagementTeams(() => {
            this.setState({ isDeleting: false });
            this.props.toggle();
        });
    }


    render() {
        const { isOpen, toggle, checkedItems } = this.props;
        const { isDeleting } = this.state;
        return (
            <div>

                <FieldModal
                    size="small"
                    isOpen={isOpen}
                    modalTitle={"Delete Engagement Teams"}
                    bodyHeaderText={''}
                    bodyContent={() => {
                        return (
                            <div>
                                <p>Are you sure you want to delete these engagement teams?</p>
                            </div>)
                    }}
                    toggle={toggle}
                    actionButtonLabel={!isDeleting ? 'Delete' : 'Deleting...'}
                    actionButton={() => {
                        this.actionButton();
                    }}

                    actionButtonDisabled={isDeleting}
                    isDelete={true}
                ></FieldModal>

            </div>
        );
    }
}

export default withRouter(DeleteEngagementTeamsModal);
